import { Box, Typography } from "@mui/material";
import styles from "./services.module.scss"
import CONSTANTS from '../../config/constants.json';

const YouthAndEducationConatctUs = () => {
  return (
    <Box className={styles.ContactUsContainer}>
      <Typography className={styles.mainHeading}>Contact Us</Typography>
      <Box className={styles.singleContainer}>
        <img src="/images/questions.svg" />
        <Typography className={styles.detailsConatiner}>
          EC Chair Youth & Education: Goutham Vedanti
        </Typography>
      </Box>
      <Box className={styles.singleContainer}>
        <img src="/images/ic_sharp-email.svg" />
        <Typography className={styles.detailsConatiner}>youthevents@{CONSTANTS.DOMAIN_NAME}</Typography>
      </Box>
      <Box className={styles.singleContainer}>
        <img src="/images/phone-call.svg" />
        <Typography className={styles.detailsConatiner}>925-449-625</Typography>
      </Box>
    </Box>
  );
};

export default YouthAndEducationConatctUs;
